const State = require('../helpers.js').State;

module.exports = State({
    cnp: '',
    postalCode: '',
    postalCodeResponse: null,
    isCompany: false,
    inProgress: false,
    personalInformation: null,
    lastPolicy: null,
    cityCode: '',
    district: '',
    date: '',
    name: '',

    //from postal code
    cityId: null,
    cityName: null,
    county: null,
    countyName: null,
    street: '',
    streetType: '',
});